export default {
    name: "ProcessesController",

    data() {
        return {
            menu: [
                {
                    title: "Asset Search",
                    icon: "mdi-magnify-expand",
                    route: "asset-search.index",
                },
                {
                    title: "Asset Swap",
                    icon: "mdi-swap-horizontal",
                    route: "asset-swap.index",
                },
                {
                    title: "Add Stock",
                    icon: "mdi-information",
                    route: "add-stock.index",
                },
                {
                    title: "Stock Transfer",
                    icon: "mdi-transfer",
                    route: "stock-transfer.index",
                },
                {
                    title: "PAT Testing",
                    icon: "mdi-hammer",
                    route: "pat.index",
                },
                {
                    title: "LOLER Testing",
                    icon: "mdi-tools",
                    route: "loler.index",
                },
                {
                    title: "PAT Records",
                    icon: "mdi-file-document",
                    route: "pat.records",
                },
                {
                    title: "LOLER Records",
                    icon: "mdi-file-document",
                    route: "loler.records",
                },
                {
                    title: "Job Reports",
                    icon: "mdi-file-chart",
                    route: "job-report.index",
                },
                {
                    title: "Accident Report",
                    icon: "mdi-book-edit",
                    route: "accident-reports.index",
                },
            ],
        };
    },
    mounted() {
        this.generateMenu();
        this.$root.store.sideMenuTitle = "Processes";
    },

    methods: {
        generateMenu() {
            this.$root.store.sideMenu = this.menu;
        },
    },
};
